// Купувачът на фискална фактура, чието закриване не е минало (BE го отказва
// ПРЕДИ бона: картов терминал, друго ФУ, няма принтер… — или заявката е
// паднала). Закриването тече във фона (`payment/backgroundBillClose.ts`) и
// модалът на купувача го няма, когато отказът пристигне; следващият избор на
// СЪЩАТА сметка във „Фактуриране“ го предлага попълнен
// (`FiscalInvoiceBuyerModal`) — операторът оправя причината (друг метод, друг
// принтер), без да въвежда фирмата наново. Само в паметта на таба: изчезва с
// презареждането и с успешното закриване на сметката.

import type { CloseBillFiscalInvoiceIn } from "../../../../../api/bills";
import type { InvoiceBuyerDraft } from "./useInvoiceBuyer";

const buyersByBillId = new Map<number, CloseBillFiscalInvoiceIn>();

export const rememberRefusedFiscalInvoiceBuyer = (
  billId: number,
  fiscalInvoice: CloseBillFiscalInvoiceIn,
): void => {
  buyersByBillId.set(billId, fiscalInvoice);
};

export const forgetRefusedFiscalInvoiceBuyer = (billId: number): void => {
  buyersByBillId.delete(billId);
};

/** Полетата на формата от запомнения купувач; `null` — няма отказ за сметката. */
export const refusedFiscalInvoiceBuyerDraftOf = (billId: number): InvoiceBuyerDraft | null => {
  const fiscalInvoice = buyersByBillId.get(billId);
  if (!fiscalInvoice) return null;
  const { customer } = fiscalInvoice;
  return {
    values: {
      eik: customer.eik,
      vat: customer.vat_number ?? "",
      name: customer.company_name,
      city: customer.city,
      address: customer.address,
      mol: customer.mol ?? "",
    },
    receivedBy: fiscalInvoice.receivedBy ?? "",
  };
};
